import axios from '../utils/axios';

export default function fetchNTCPremiumJobs(adminId, params) {
    return axios.get(`/admin/${adminId}/ntc-premium-jobs`, { params })
        .then(res => res.data)
        .catch(err => err);
}
